import XEUtils from 'xe-utils';
import { VxeCore } from './core';
import { iconConfigStore } from './iconStore';
export function setIcon(options) {
    if (options) {
        Object.assign(iconConfigStore, options);
    }
    return VxeCore;
}
export function getIcon(key) {
    return arguments.length ? XEUtils.get(iconConfigStore, key) : iconConfigStore;
}
